import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Image from 'next/image';
// import cn from 'classnames';
import Balancer from 'react-wrap-balancer';

import Video from 'react-scale/components/elements/video';
import Lidar from 'react-scale/components/pages/customers/Lidar';

// import styles from './FeatureTitle.module.css';

const FeatureTitle = ({ overtitle, title, subtitle, video, image, lidar, caption }) => (
  <>
    <div className="basis-1/3">
      {overtitle && (
        <p className="sticky top-0 pt-1 mt-2 mb-2 text-2xl capitalize">
          {typeof overtitle === 'string' ? overtitle : overtitle.text}
        </p>
      )}
    </div>
    <div className="basis-2/3">
      {title && (
        <h2 className="mb-8 text-3xl text-black font-aeonik md:text-5xl">
          <Balancer>{title}</Balancer>
        </h2>
      )}
      {subtitle && (
        <div>
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            className="max-w-full prose prose-lg prose-p:text-neutral-900 prose-li:text-neutral-900 prose-li:marker:text-neutral-900"
          >
            {subtitle}
          </ReactMarkdown>
        </div>
      )}
      {video?.url && <Video className="mt-12" url={video.url} poster={video.poster} />}
      {!video?.url && image && (
        <div className="relative">
          <div className="mt-12">
            <Image
              className="overflow-hidden rounded-lg shadow-2xl"
              src={image.url}
              width={image.width}
              height={image.height}
              alt={image.alt}
              layout="responsive"
            />
          </div>
        </div>
      )}
      {lidar && <Lidar url={lidar} />}
      {caption && (
        <ReactMarkdown rehypePlugins={[rehypeRaw]} className="mt-16 text-lg text-neutral-900">
          {caption}
        </ReactMarkdown>
      )}
    </div>
  </>
);

FeatureTitle.defaultProps = {
  overtitle: null,
  subtitle: null
};

export default FeatureTitle;
